import { createFileRoute } from '@tanstack/react-router'

import { PageContent } from '@/components/page-content'
import { PageHeader } from '@/components/page-header'
import { QualificationsForm } from '@/features/jobs/qualification/components/QualificationsForm'

export const Route = createFileRoute('/_authenticated/jobs_/$jobId_/edit/qualification')({
  component: RouteComponent,
})

function RouteComponent() {
  const { jobId } = Route.useParams()

  return (
    <>
      <PageHeader title="Qualification" />
      <PageContent>
        <QualificationsForm jobId={jobId} />
      </PageContent>
    </>
  )
}
